import { useCallback, useState } from "react";
import {
  type HomeCardKey,
  type HomeCardsPreferences,
  readHomeCardsPreferences,
  writeHomeCardsPreferences,
  anyHomeCardEnabled,
  HOME_CARDS_STORAGE_KEY,
} from "@/lib/homeCardsPreferences";

const LEGACY_SHOW_EXTRAS_KEY = "deeply_home_show_extras";

export function useHomeCardsPreferences() {
  const [prefs, setPrefsState] = useState<HomeCardsPreferences>(() => {
    const loaded = readHomeCardsPreferences();
    if (typeof window !== "undefined") {
      try {
        const hadNew = localStorage.getItem(HOME_CARDS_STORAGE_KEY) !== null;
        const hadLegacy = localStorage.getItem(LEGACY_SHOW_EXTRAS_KEY) !== null;
        if (!hadNew && hadLegacy) {
          writeHomeCardsPreferences(loaded);
        }
      } catch {
        /* ignore */
      }
    }
    return loaded;
  });

  const setPrefs = useCallback((next: HomeCardsPreferences) => {
    setPrefsState(next);
    writeHomeCardsPreferences(next);
  }, []);

  const setCard = useCallback((key: HomeCardKey, enabled: boolean) => {
    setPrefsState((prev) => {
      const next = { ...prev, [key]: enabled };
      writeHomeCardsPreferences(next);
      return next;
    });
  }, []);

  const toggleCard = useCallback((key: HomeCardKey) => {
    setPrefsState((prev) => {
      const next = { ...prev, [key]: !prev[key] };
      writeHomeCardsPreferences(next);
      return next;
    });
  }, []);

  return {
    prefs,
    setPrefs,
    setCard,
    toggleCard,
    anyEnabled: anyHomeCardEnabled(prefs),
  };
}
